import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {Field, formValueSelector, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import {hashHistory} from 'react-router';
import Cookies from 'cookies-js';
import {FormattedMessage, injectIntl} from "react-intl";

import {login} from '../../actions';
import {modifyPageLayoutComponents} from '../PageLayout';
import * as actions from '../../actions';
import SimpleDropDown from "../PageLayout/DropDowns/SimpleDropDown/SimpleDropDown";
import {required} from "../AddNewEntity/formField";
import {resetPassword} from "../../actions/resetPassword";

const managementOptions = [
  {text: 'Version 8.0 (Legacy)', id: 'KitchenDB'},
  {text: 'Version 9.0', id: 'BathDB'}
];

const LOGIN_VIEW_TYPES = {
  login: "login",
  reset: "reset",
  resetSuccess: "resetSuccess",
};

const EMAIL_REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]*$/i;

class loginContent extends Component {
  constructor(props) {
    super(props);

    window.managing = window.managing || managementOptions[1].id; // 9.0 should be by the default
    Cookies.set('managing', window.managing);

    var manage = managementOptions[1];
    var managingIdx = managementOptions.findIndex(f => f.id == window.managing);
    if (managingIdx >= 0) {
      manage = managementOptions[managingIdx];
    }

    this.state = {
      invalidUserOrPass: false,
      invalidEmail: false,
      text: '',
      manage,
      isLoading: false,
      viewType: this.getDefaultViewType()
    }
  }

  getDefaultViewType = () => this.props.routeParams.reset ? LOGIN_VIEW_TYPES.reset : LOGIN_VIEW_TYPES.login

  componentDidMount() {
    this.props.hideLoadingOverlay();
    document.documentElement.classList.add("pricing-page");
    document.body.classList.add("pricing-page");
  }

  componentWillUnmount() {
    document.documentElement.classList.remove("pricing-page");
    document.body.classList.remove("pricing-page");
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this.setState({
        viewType: this.getDefaultViewType()
      })
    }
  }

  handleFormSubmit = (form) => {
    const {email, password} = form;

    const invalidEmail = !EMAIL_REGEX.test(email)
    this.setState({ invalidEmail });
    if (invalidEmail) {
      return;
    }

    if (this.state.viewType === LOGIN_VIEW_TYPES.reset) {
      this.resetPasswordSubmit();
      return
    }

    this.setState({isLoading: true});
    this.props.login({email, password}, 0)
      .catch((error) => {
        console.info("login error", error);
        this.setState({invalidUserOrPass: true, isLoading: false});
      })
      .then(() => {
        const redirectTo = actions.getRedirectTo() || "/";
        hashHistory.push(redirectTo);
      })
    ;
  };

  resetPasswordSubmit = () => {
    const {inputEmail} = this.props;
    this.props.resetPassword({email: inputEmail})
      .catch(() => {
        this.setState({invalidUserOrPass: true, isLoading: false});
      })
      .then((response) => {
        this.setState({
          isLoading: false
        });
        if (response && response.__error__) { // popup will show incorrect email
          return false
        }
        this.setState({
          viewType: LOGIN_VIEW_TYPES.resetSuccess,
        });
      });
  }

  handleTextChanged = (e) => {
    this.setState({text: e.target.value});
  };

  setManaging = (managing) => {
    window.managing = managing.id;
    Cookies.set('managing', managing.id);
    this.setState({manage: managing});
  }

  handleResetButtonClick = () => {
    hashHistory.push("login/reset-password");
    this.setState({ invalidUserOrPass: false });
  }

  handleReturnToLoginButtonClick = () => {
    hashHistory.push("login");
  }

  handleUserEmailBlur = () => {
    const {inputEmail} = this.props;
    const invalidEmail = inputEmail && !EMAIL_REGEX.test(inputEmail)
    this.setState({ invalidEmail });
  }

  handleUserEmailChange = (event) => {
    if (this.state.invalidEmail) {
      const invalidEmail = !EMAIL_REGEX.test(event.target.value)
      this.setState({ invalidEmail });
    }
  }

  render() {

    const {handleSubmit, submitting, pristine, inputEmail, intl} = this.props;
    const logo = "https://qc-cdn.s3.amazonaws.com/Logos/quote-gray.svg";

    return (
      <div className="login-form">
        <div className="login-form__logo">
          <div className="login-form__logo-image" style={{backgroundImage: `url(${logo})`}}/>
          <span className="login-form__logo-text">
            <FormattedMessage id="dashboard.loginPage.title"/>
          </span>
        </div>
        <form onSubmit={handleSubmit(this.handleFormSubmit)} className="login-form__content">
          <div className="login-form__container">
            {this.state.viewType === LOGIN_VIEW_TYPES.resetSuccess ? (
              <Fragment>
                <div className="login-form__row login-form__text text-center">
                  <FormattedMessage id="dashboard.loginPage.resetSuccessText"/>
                </div>
                <div className="login-form__email text-center">{inputEmail}</div>
              </Fragment>
            ) : (
              <Fragment>
                {this.state.viewType === LOGIN_VIEW_TYPES.reset
                  ? <div className="login-form__row login-form__text"><FormattedMessage id="dashboard.loginPage.forgotPasswordText"/></div>
                  : null}
                <div className="login-form__row">
                  <div className="login-form__input">
                    <label htmlFor="input_email" className="ui-input__label text-uppercase">
                      <FormattedMessage id="dashboard.loginPage.userEmail"/>
                    </label>
                    <Field component="input"
                           id="input_email"
                           className="ui-input ui-input--gray4 text-left"
                           type="text"
                           placeholder={intl.formatMessage({id: "dashboard.loginPage.userEmail"})}
                           validate={required}
                           onBlur={this.handleUserEmailBlur}
                           onChange={this.handleUserEmailChange}
                           name="email"/>
                  </div>
                  {this.state.viewType === LOGIN_VIEW_TYPES.login ? (
                    <div className="login-form__input">
                      <label htmlFor="input_password" className="ui-input__label text-uppercase">
                        <FormattedMessage id="dashboard.loginPage.password"/>
                      </label>
                      <Field component="input"
                             id="input_password"
                             className="ui-input ui-input--gray4 text-left"
                             type="password"
                             placeholder={intl.formatMessage({id: "dashboard.loginPage.password"})}
                             validate={required}
                             name="password"/>
                    </div>
                  ) : null}
                </div>
              </Fragment>
            )}
            {this.state.invalidUserOrPass || this.state.invalidEmail ? (
              <div className="login-form__row login-form__row--right login-form__row--error">
                <p className="notice">
                  <FormattedMessage id={this.state.invalidEmail
                    ? "dashboard.loginPage.errors.incorrectEmail" : "dashboard.loginPage.errors.incorrectUserOrPass"}/>
                </p>
              </div>
            ) : null}
            <div className="login-form__row" style={{display: "none"}}>
              <h2>Login For</h2>
              <SimpleDropDown id="manage"
                              values={managementOptions}
                              activeValue={this.state.manage}
                              onChange={this.setManaging}/>
            </div>
            <div className="login-form__row login-form__row--right">
              {this.state.viewType === LOGIN_VIEW_TYPES.reset || this.state.viewType === LOGIN_VIEW_TYPES.resetSuccess
                ? <span className="ui-link" onClick={this.handleReturnToLoginButtonClick}><FormattedMessage id="dashboard.loginPage.forgotPasswordReturn"/></span>
                : <span className="ui-link" onClick={this.handleResetButtonClick}><FormattedMessage id="dashboard.loginPage.forgotPassword"/></span>}
              {this.state.viewType === LOGIN_VIEW_TYPES.reset ? (
                <button className="ui-button5 ui-button5--green" type="submit"
                        disabled={pristine || submitting}><FormattedMessage id="dashboard.loginPage.resetButton"/></button>
              ) : null}
              {this.state.viewType === LOGIN_VIEW_TYPES.login ? (
                <button className="ui-button5 ui-button5--green" type="submit"
                        disabled={pristine || submitting}><FormattedMessage id="dashboard.loginPage.loginButton"/></button>
              ) : null}
              {this.state.isLoading ? <div className="ui-loader ui-loader--after-button"/> : null}
            </div>
          </div>
        </form>
      </div>
    )
  }
}

loginContent.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired
};

const mapDispatchToProps = dispatch => ({
  login: (email, password) => dispatch(login(email, password)),
  hideLoadingOverlay: () => dispatch(actions.loadingDialog_show(false)),
  resetPassword: (data) => dispatch(resetPassword(data)),
});

const mapStateToProps = state => {
  const selector = formValueSelector('login') // <-- same as form name
  return {
    inputEmail: selector(state, 'email')
  }
};

const LoginLayoutComponents = modifyPageLayoutComponents({
  pageHeader: () => null,
  content: injectIntl(connect(mapStateToProps, mapDispatchToProps)(reduxForm({form: 'login'})(loginContent)))
});

export {LoginLayoutComponents};
